module.exports = __webpack_public_path__ + "img/solid-background-map-hours-dark.850a3663.png";